import { useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BrandIcon } from "@/components/Brand";

export const Footer = () => {
  const navigate = useNavigate();
  const taps = useRef({ count: 0, timer: null });

  const handleStealthTap = () => {
    const t = taps.current;
    t.count += 1;
    if (t.timer) clearTimeout(t.timer);
    if (t.count >= 5) {
      t.count = 0;
      navigate("/staff");
      return;
    }
    t.timer = setTimeout(() => { t.count = 0; }, 1200);
  };

  const links = [
    { to: "/privacy", label: "Privacy Policy" },
    { to: "/terms", label: "Terms of Service" },
    { to: "/account/delete", label: "Account Deletion" },
    { to: "/safety", label: "Safety Standards" },
    { to: "/support", label: "Member Support" },
    { to: "/partnerships", label: "Partner With Us" },
  ];

  return (
    <footer className="bg-[#090D16] border-t border-white/[0.06]">
      <div className="max-w-5xl mx-auto px-6 py-10 flex flex-col items-center gap-5 text-center">
        <Link to="/" aria-label="Sparkd home" className="flex items-center gap-2.5">
          <BrandIcon className="h-7 w-auto object-contain" />
          <span className="font-heading text-xl font-extrabold tracking-tight text-white leading-none select-none">
            Spark<span className="text-[#F43F5E]">d</span>
          </span>
        </Link>
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-slate-400">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="hover:text-white transition-colors">
              {l.label}
            </Link>
          ))}
        </nav>
        <span
          onClick={handleStealthTap}
          data-testid="footer-copyright"
          className="select-none cursor-default text-xs text-slate-500"
        >
          © 2026 Sparkd. All rights reserved.
        </span>
      </div>
    </footer>
  );
};
